var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"test-suite-chip white--text",style:({ background: _vm.color })},_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t(`testSuite.statuses.${_vm.value}`)))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }